module.exports = __webpack_public_path__ + "static/img/betterez-1.fce3797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/betterez-1.jpg
// module id = lRLD
// module chunks = 1